module.exports = __webpack_public_path__ + "static/media/ems-station.9706d4b5.svg";